/* eslint-disable object-shorthand */

export const PACKAGE_BUILD_DATE = '2026-10-19T03:07:07.245Z';
export const PACKAGE_NAME = '@invision/authentication';
export const PACKAGE_VERSION = '3.6.0-2658901';

export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};
